const personalInfoInputs = (defaults) => {
    return {
        has_diseases: {
            elementType: "switch",
            elementConfig: {
                label: "بیماری دارم",
                variant: "outlined",
                value: defaults.has_diseases,
            },
            gridConfig: {
                xs: 12,
                sm: 12,
                md: 6,
            },
        },
        diseases: {
            elementType: "text-field",
            elementConfig: {
                label: "توضیحات",
                variant: "outlined",
                value: defaults.diseases ?? "",
                multiline: true,
                rows: 2,
            },
            gridConfig: {
                xs: 12,
                sm: 12,
                md: 12,
            },
        },
    }}

    export default personalInfoInputs;